export const GeneralSettings = Object.freeze({
	DATE_FORMAT: 'DefaultDateFormat',
	DATE_TIME_FORMAT: 'DefaultDateTimeFormat',
	GRID_ASSET_WIDTH: 'DefaultWidthAssetsGrid ',
	GRID_CATALOG_WIDTH: 'DefaultWidthCatalogsGrid ',
	GRID_LOCATION_WIDTH: 'DefaultWidthLocationsGrid ',
	GRID_DEPARTMENT_WIDTH: 'DefaultWidthDepartmentsGrid ',
	GRID_NAMES_WIDTH: 'DefaultWidthNamesGrid ',
	GRID_CUSTOM_TABLE_WIDTH: 'DefaultWidthCustomGrid ',
	USER_DISPLAY_FORMAT: 'DefaultUserDisplayFormat ',
	PRIMARY_KEY_EXEPTION_LIST: 'PrimaryKeyExeptionList ',
});
